<template>
  <v-card>
    <v-data-table
      :page.sync="page"
      @page-count="pageCount = $event"
      :items="students"
      :headers="headers"
      hide-default-footer
    >
      <template v-slot:item.srno="{ item }">
        <span class="table-tutor-srno">{{item.srno}}</span>
      </template>

      <template v-slot:item.name="{ item }">
        <span class="table-tutor-name">{{item.name}}</span>
      </template>
      <template v-slot:item.schedule="{ item }">
        <span class="table-tutor-time">{{item.time}}</span>
        <span class="table-tutor-days">{{item.days}}</span>
      </template>

      <template v-slot:item.tutor="{ item }">
        <span class="table-tutor-tutor">{{item.tutor}}</span>
      </template>
    </v-data-table>
    <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Classes
        <span
          :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{students.length}}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ClassTable",
  data() {
    return {
      dialog: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        { text: "SrNo.", sortable: true, value: "srno" },
        { text: "Student Name", value: "name", sortable: true },
        { text: "Class", value: "class", sortable: true },
        { text: "Subject", value: "class_subject_group.subject.subject_name", sortable: false },
        { text: "Assigned Tutors", value: "tutor", sortable: true },
        { text: "Tutors Days & Time", value: "schedule", sortable: false }
      ],
    };
  },
props: ['tab'],
  methods: {
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    }
  },
   watch: {
    tab: function(val) {
       // watch it
          console.log('Prop changed: ', val)
        // if(val == 0){
        // this.getItems()
        // }
        }
  },
};
</script>

<style lang='scss'>
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}
.table-tutor {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }
  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }
  &-email {
    font: 400 12px/13px Lato;
    color: #172b4d4d;
  }
  &-time {
    display: block;
    font: 400 11px/10px Lato;
    color: #0e0edff7;
  }
  &-days {
    font: 400 10px/15px Lato;
    color: #172b4db3;
  }
  &-tutor {
    font: 500 13.5px Gotham;
    color: #529b11;
  }
}

.v-btn.v-size--default {
  font-size: 12px;
  text-transform: none;
}
</style>